import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/civicactions/Sites/data-catalog-components/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "data-catalog-components"
    }}>{`Data Catalog Components`}</h1>
    <p>{`A set of React components to facilitate the creation of Open Data Catalogs with React.`}</p>
    <h2 {...{
      "id": "components"
    }}>{`Components`}</h2>
    <p>{`Components are the building blocks of the library. Most components should be able to be used independently on your site.`}</p>
    <h2 {...{
      "id": "services"
    }}>{`Services`}</h2>
    <p>{`Services are mainly functions, classes, and config that components may use. The Search and Resource components are built using React's useContext and useReducer hooks. Services holds the reducer and actions for each of these components. `}</p>
    <h2 {...{
      "id": "templates"
    }}>{`Templates`}</h2>
    <p>{`Templates are components that have basic styling and layout. Usually these components will consist of multiple components in the library that are setup and ready to use. You can either pull these components into your own project using an `}<inlineCode parentName="p">{`import`}</inlineCode>{` statement or copy and paste the component rewriting the `}<inlineCode parentName="p">{`imports`}</inlineCode>{` and customizing it to match the style of your site.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      